import { combineReducers } from "redux";
import authReducer from "./slice/auth.slice.js";
import gameReducer from "./slice/game.slice.js";
import userReducer from "./slice/user.slice.js";
import reviewReducer from "./slice/review.slice.js";
import categoryReducer from "./slice/category.slice.js";
import adminUserReducer from "./slice/adminUser.slice.js";
import homeReducer from "./slice/home.slice.js";
import blogReducer from "./slice/blog.slice.js";
import discountReducer from "./slice/discount.slice.js";
import subscriberReducer from "./slice/subscriber.slice.js";
import gatewayReducer from "./slice/gateway.slice.js";
import contactReducer from "./slice/contact.slice.js";
import orderReducer from "./slice/order.slice.js";
import faqReducer from "./slice/faq.slice.js";
import privacyPolicyReducer from "./slice/privacyPolicy.slice.js";
import termsOfServiceReducer from "./slice/termsOfService.slice.js";
import restoreReducer from "./slice/restore.slice.js";

export const rootReducer = combineReducers({
    auth: authReducer,
    game: gameReducer,
    userSlice: userReducer,
    review: reviewReducer,
    category: categoryReducer,
    adminUser: adminUserReducer,
    home: homeReducer,
    blog: blogReducer,
    discount: discountReducer,
    subscriber: subscriberReducer,
    gateway: gatewayReducer,
    contact: contactReducer,
    order: orderReducer,
    faq: faqReducer,
    privacyPolicy: privacyPolicyReducer,
    termsOfService: termsOfServiceReducer,
    restore: restoreReducer,
});